// extracted by mini-css-extract-plugin
module.exports = {"errorIndicatorContainer":"styles_errorIndicatorContainer__1yCoD","mailToSupport":"styles_mailToSupport__1olA1"};